export default __webpack_public_path__ + "static/media/A_arte_de_brincar_3.07a21148.jpg";